/* WINGBABE · countdown · vanilla JS, no dependencies */
(function(){
/* Evergreen per-session timer: starts at data-countdown-seconds, stored in sessionStorage, restarts when it hits 0. */
function get(k){try{return +sessionStorage.getItem(k);}catch(e){return 0;}}
function set(k,v){try{sessionStorage.setItem(k,v);}catch(e){}}
document.querySelectorAll('[data-countdown]').forEach(function(el,i){var k='wb-cd-'+i,dur=+el.dataset.countdownSeconds||10800,label=el.getAttribute('data-countdown-label')||'Ends in',end=get(k);
 if(!end||end<Date.now()){end=Date.now()+dur*1000;set(k,end);}
 function p(n){return (n<10?'0':'')+n;}
 function tick(){var s=Math.max(0,Math.round((end-Date.now())/1000));if(!s){end=Date.now()+dur*1000;set(k,end);}el.textContent=label+' '+p(Math.floor(s/3600))+':'+p(Math.floor(s/60)%60)+':'+p(s%60);}
 tick();setInterval(tick,1000);});
})();
